import React, { useMemo } from 'react';
import classes from './AttributeIcon.module.scss';
import { Icon } from '../../images/Icon/Icon';
import { IconsEnum } from '../../../constants/icons';
import { WithChildren } from '../../../models/children-props';
import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';
import { Tooltip } from '../../actions/Tooltip';
import { idGenerator } from '../../../helpers/idGenerator';
import scssVars from '../../../assets/scss/exportedVars.module.scss';

export type AttributeIconViewProps = WithChildren & {
  icon: IconsEnum;
  iconColor?: 'GREEN';
  useInview?: boolean;
  toolTip?: string | JSX.Element;
};

export const AttributeIconView = (props: AttributeIconViewProps): JSX.Element => {
  const { ref, inView } = useInView({
    threshold: 1
  });

  const id = useMemo(() => idGenerator(), []);

  const { icon, children, useInview, toolTip } = props;
  const attributeId = toolTip ? `attribute-${icon}-${id}` : undefined;

  const iconContainerClasses = classNames('grid-x', 'align-middle', { hide: !inView && useInview === false });
  const iconWrapperClasses = classNames('cell', 'shrink', classes.IconWrapper, {
    [classes.IconWrapperGREEN]: props.iconColor === 'GREEN'
  });

  return (
    <div className={classNames('cell', 'shrink', classes.Wrapper)}>
      {props.toolTip && (
        <Tooltip
          type={'regular'}
          pointer={true}
          target={`#${attributeId}`}
          autoZIndex={false}
          position={'bottom'}
          style={{ zIndex: scssVars['z-index-overmodal'] }}>
          <>{props.toolTip}</>
        </Tooltip>
      )}
      <div className={iconContainerClasses} ref={ref} id={attributeId}>
        <div className={iconWrapperClasses}>
          <Icon name={icon} size={'medium'} />
        </div>
        {children ? <div className={classNames(classes.Label, 'cell shrink')}>{children}</div> : null}
      </div>
    </div>
  );
};
